/* tslint:disable */

declare var Object: any;
export interface ERPsalesCustomerInterface {
  "id"?: number;
}

export class ERPsalesCustomer implements ERPsalesCustomerInterface {
  "id": number;
  constructor(data?: ERPsalesCustomerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPsalesCustomer`.
   */
  public static getModelName() {
    return "ERPsalesCustomer";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPsalesCustomer for dynamic purposes.
  **/
  public static factory(data: ERPsalesCustomerInterface): ERPsalesCustomer{
    return new ERPsalesCustomer(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPsalesCustomer',
      plural: 'ERPsalesCustomers',
      path: 'ERPsalesCustomers',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPsalesCustomer.ts